@if (isContactInfoVisible) {
  <div class="row text-center p-4">
    <h5 class="text-uppercase fw-bold mb-4">
      Contact
    </h5>
    @if (isBrandAddressVisible) {
      <p><fa-icon [icon]="faUniversity"></fa-icon> {{brandAddress}}</p>
    }
    @if (isBrandCityStateZipVisible) {
      <p>{{brandCity}}, {{brandState}} {{brandPostalCode}}</p>
    }
    @if (isBrandEmailAddressVisible) {
      <p><fa-icon [icon]="faEnvelopeOpen"></fa-icon> {{brandEmailAddress}}</p>
    }
    @if (isBrandTelephoneVisible) {
      <p><fa-icon [icon]="faPhone"></fa-icon> {{brandTelephone}}</p>
    }
  </div>
}

@if (isBrandWebSiteVisible) {
  <div class="row text-center p-6" style="background-color: rgba(0, 0, 0, 0.05);">
    <p>©{{copyrightYear}} Copyright:</p>
    <a class="text-reset fw-bold" href="{{brandWebSite}}">{{brandName}}</a>
  </div>
}

